import React, { useContext, useEffect, useState } from "react";
import SideBar from "../inc/SideBar";
import NavBar from "../inc/NavBar";
import {
  Col,
  Container,
  Image,
  Row,
  Modal,
  Button,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Logo1 from "../images/logo1.png";
import Logo from "../images/logo.svg";
import FlagIcon from "../images/aus.png";
import FlagIcon1 from "../images/french.svg";
import MessageIcon2 from "../../web_components/images/message-2.png";
import EditIcon2 from "../images/edit-2.svg";
import BuildingIcon2 from "../../web_components/images/company.png";
import PaymentIcon2 from "../images/payment.svg";
import UserSquare from "../../web_components/images/user-square.png";
import Select from "react-select";
import { Link } from "react-router-dom";
import { AiFillPlusCircle } from "react-icons/ai";
import {
  country_PhoneNumberCode,
  edit_AdminProfile,
  getAdminDetail,
  staff_EditAccount,
  staff_PaticularDetail,
  uploadImage,
  checkCarrierValidation,
  add_carrier_preference,
  get_carrier_preference,
  remove_carrier_preference,
  enable_preferred_carriers,
} from "../services/ApiCalls";
import TextInputWithLabel from "../customcomponents/TextInputWithLabel";
import { ToastContainer, toast } from "react-toastify";
import LoadingContext from "../services/LoadingContext";
import { setNumberValidation } from "../services";
import * as SERVICE from "../services/index";
import { QuotesDataContext } from "../services/QuotesData";
import {
  user_Detail,
  user_EditDetail,
} from "../services/UserApiServices/UserApiCalls";
import { BASE_URL, IMAGE_URL } from "../services/env";
import { HiUser } from "react-icons/hi2";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  geocodeByPlaceId,
} from "react-places-autocomplete";
import { FaLocationDot } from "react-icons/fa6";
import { AppStoreContext } from "../../store/AppStore";
import Loader from "../../common/component/Loader";
import consoleService from "../../utility/services/consoleService";
import CustomHookFunctions from "../services/CustomHookFunctions";
import { RxCrossCircled } from "react-icons/rx";
import { IoIosInformationCircleOutline } from "react-icons/io";

const options = [
  {
    id: 1,
    value: "English",
    label: (
      <div>
        <Image src={FlagIcon} alt="country-image" /> English
      </div>
    ),
  },
  {
    id: 2,
    value: "French",
    label: (
      <div>
        <Image src={FlagIcon1} alt="country-image" /> Français
      </div>
    ),
  },
];

const Account = () => {
  const { userDetail, setUserDetails } = useContext(AppStoreContext);
  console.log("userDetail", userDetail);

  const {
    accountNumber,
    contactemail,
    contactPhone,
    companyName,
    accountOnwerLastName,
    accountOnwerFirstName,
    CountryCode,
    profile,
    vat,
    paymentBIC,
    paymentIBAN,
    address,
    siret,
    pic,
    contactCode,
    accountOwnerFirstName,
    accountOwnerLastName,
    accountOwnerPhoneNumber,
    accountOwnerEmail,
    DUNS,
    IBAN,
    contactEmail,
    BIC,
    phoneNumber,
    firstName,
    lastName,
    countryCode,
    email,
    phone_Number,
    duns,
    rcs,
    vat_number,
    accountOnwerName,
    accountPhoneNumber,
    accountEmail,
    LoginId,
    accountOwnerCode,
    mangerEmail,
    Position,
    contact_first_name,
    contact_last_name,
    countryName,
    prefferedCarrierToggle,
  } = userDetail;

  const userRole = profile;
  const [editContactLoading, setEditContactLoading] = useState(false);
  const [editCompanyLoading, setEditCompanyLoading] = useState(false);
  const [editPaymentLoading, setEditPaymentLoading] = useState(false);
  const [editManagerLoading, setEditManagerLoading] = useState(false);
  const [countyIsoCode, setCountyIsoCode] = useState("");

  const isRoleUser = userRole == "User";
  const isRoleCarrier = userRole == "Carrier";
  const isRoleClient = userRole == "Client";
  const isRoleAdmin = userRole == "Admin";
  const isRoleStaff = userRole == "Staff";
  ////////////////////////////////////////// OLD VARIABLES ///////////////////////////////////////////////////////

  const { accountDetail, setAccountDetail } = useContext(QuotesDataContext);
  const [selOption, setSelectedOption] = useState(false);

  const [imageSrc, setImageSrc] = useState(null);

  const [isImage, setIsImage] = useState(false);
  const [profilePreview, setProfilePreview] = useState(null);
  const [contactModal, setContactModal] = useState(false);
  const [companyModal, setCompanyModal] = useState(false);
  const [accountModal, setAccountModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [ownerFirstName, setOwnerFirstName] = useState("");
  const [ownerLastName, setOwnerLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [ContactEmail, setContactEmail] = useState("");
  const [conTactCompanyName, setContactCompanyName] = useState("");
  const [compnayDuns, setCompanyDuns] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountOwnerPhone, setAccountOwnerPhone] = useState("");
  const [AccountOwnerEmail, setAccountOwnerEmail] = useState("");
  const [iban, setIban] = useState("");
  const [bic, setBic] = useState("");
  const [user_rcs, setRcs] = useState("");

  const [modalData, setModalData] = useState({});

  const [preferredCarriersModal, setPreferredCarriersModal] = useState(false);

  const { setIsLoading } = useContext(LoadingContext);

  // error
  const [Submit, setSubmit] = useState(false);
  const [errorCount, seterrCount] = useState(0);

  const [userFirstNameErr, setUserFirstNameErr] = useState("");
  const [userLastNameErr, setUserLastNameErr] = useState("");
  const [userSiretError, setUserSiretError] = useState("");
  const [userVatError, setUserVatError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [contactEmailError, setContactEmailError] = useState("");
  const [contactFirstNameError, setContactFirstNameError] = useState("");
  const [contactLastNameError, setContactLastNameError] = useState("");
  const [conTactCompanyNameError, setContactCompanyNameError] = useState("");
  const [companyAddressError, setCompanyAddressError] = useState("");
  const [accountNameError, setAccountNameError] = useState("");
  const [accountOwnerPhoneError, setAccountOwnerPhoneError] = useState("");
  const [accountOwnerEmailError, setAccountOwnerEmailError] = useState("");
  const [ibanError, setIbanError] = useState("");
  const [bicError, setBicError] = useState("");

  // MODIFIED STATES
  const [user_profile_pic, setUserProfilePic] = useState("");
  const [user_first_name, setUserFirstName] = useState("");
  const [user_account_number, setUserAccountNumber] = useState("");
  const [user_last_name, setUserLastName] = useState("");
  const [user_phone, setUserPhone] = useState("");
  const [user_email, setUserEmail] = useState("");
  const [manager_first_name, setManageFirstrName] = useState("");
  const [manager_last_name, setManagerLastName] = useState("");
  const [manager_email, setManagerEmail] = useState("");
  const [manager_phone, setManagerPhone] = useState("");
  const [manager_postion, setManagerPosition] = useState("");
  const [manager_country_code, setManagerCountryCode] = useState("");
  const [company_name, setCompanyName] = useState("");
  const [user_duns, setUserDuns] = useState("");
  const [user_company_address, setUserCompanyAddress] = useState("");
  const [user_iban, setUserIban] = useState("");
  const [user_vat, setUserVat] = useState("");
  const [user_siret, setUserSiret] = useState("");
  const [user_bic, setUserBic] = useState("");
  const [user_country_code, setUserCountryCode] = useState("");

  // EDITED STATES
  const [countryError, setCountryError] = useState(0);
  const [country, setCountry] = useState("");
  const [edit_user_profile_pic, setEditUserProfilePic] =
    useState(user_profile_pic);
  const [edit_user_first_name, setEditUserFirstName] =
    useState(user_first_name);
  const [edit_user_last_name, setEditUserLastName] = useState(user_last_name);

  const [edit_user_phone, setEditUserPhone] = useState(user_phone);
  const [edit_user_email, setEditUserEmail] = useState(user_email);
  const [contactFirstName, setContactFirstName] = useState(contact_first_name);
  const [contactLastName, setContactLastName] = useState(contact_last_name);
  const [edit_company_name, setEditCompanyName] = useState(company_name);
  const [edit_user_duns, setEditUserDuns] = useState(user_duns);
  const [edit_user_company_address, setEditUserCompanyAddress] =
    useState(user_company_address);
  const [edit_user_iban, setEditUserIban] = useState(user_iban);
  const [edit_user_vat, setEditUserVat] = useState(vat_number);
  const [edit_user_siret, setEditUserSiret] = useState(user_siret);
  const [edit_user_bic, setEditUserBic] = useState(user_bic);
  const [edit_user_country_code, setEditUserCountryCode] =
    useState(user_country_code);
  const [edit_manager_first_name, setEditManageFirstrName] = useState("");
  const [edit_manager_last_name, setEditManagerLastName] = useState("");
  const [edit_manager_email, setEditManagerEmail] = useState("");
  const [edit_manager_phone, setEditManagerPhone] = useState("");
  const [edit_manager_country_code, setEditManagerCountryCode] = useState("");
  const [edit_rcs, setEditRcs] = useState("");

  const [phoneNumberCode, setPhoneNumberCode] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState("+33");
  const [unLoadingCountryCode, setUnLoadingCountryCode] = useState("+33");

  const [countrycode, setCountrycode] = useState(null);
  const [countryNames, setCountryNames] = useState(null);

  const [carrierInput, setCarrierInput] = useState("");
  const [carrierList, setCarrierList] = useState([]); // { account_number, _id }
  const [errorMsg, setErrorMsg] = useState("");
  const [showPreferredCarriers, setShowPreferredCarriers] = useState(false);

  const { isValidString } = CustomHookFunctions();

  // USE EFFECT TO MODIFIE STATES

  useEffect(() => {
    if (isRoleUser) {
      isValidString(accountOnwerFirstName) &&
        setUserFirstName(accountOnwerFirstName);
      isValidString(accountOnwerLastName) &&
        setUserLastName(accountOnwerLastName);
      isValidString(accountNumber) && setUserAccountNumber(accountNumber);
      isValidString(contactPhone) && setUserPhone(contactPhone);
      isValidString(contactemail) && setUserEmail(contactemail);
      isValidString(companyName) && setCompanyName(companyName);
      isValidString(address) && setUserCompanyAddress(address);
      isValidString(paymentIBAN) && setUserIban(paymentIBAN);
      isValidString(vat) && setUserVat(vat);
      isValidString(siret) && setUserSiret(siret);
      isValidString(paymentBIC) && setUserBic(paymentBIC);
      isValidString(CountryCode) && setUserCountryCode(CountryCode);
      isValidString(accountOnwerFirstName) &&
        setManageFirstrName(accountOnwerFirstName);
      isValidString(accountOnwerLastName) &&
        setManagerLastName(accountOnwerLastName);
      isValidString(accountEmail) && setManagerEmail(accountEmail);
      isValidString(accountPhoneNumber) && setManagerPhone(accountPhoneNumber);
      isValidString(contactCode) && setManagerCountryCode(contactCode);
      isValidString(prefferedCarrierToggle) &&
        setShowPreferredCarriers(prefferedCarrierToggle);

      if (pic && pic.length > 0) {
        setUserProfilePic(pic[0]);
      }

      // SET EDITED STATES
      isValidString(accountOnwerFirstName) &&
        setEditUserFirstName(accountOnwerFirstName);
      isValidString(accountOnwerLastName) &&
        setEditUserLastName(accountOnwerLastName);

      isValidString(contactPhone) && setEditUserPhone(contactPhone);
      isValidString(contactemail) && setEditUserEmail(contactemail);
      isValidString(companyName) && setEditCompanyName(companyName);
      isValidString(address) && setEditUserCompanyAddress(address);
      isValidString(paymentIBAN) && setEditUserIban(paymentIBAN);
      isValidString(vat) && setEditUserVat(vat);
      isValidString(siret) && setEditUserSiret(siret);
      isValidString(paymentBIC) && setEditUserBic(paymentBIC);
      isValidString(CountryCode) && setEditUserCountryCode(CountryCode);
      isValidString(accountOnwerFirstName) &&
        setEditManageFirstrName(accountOnwerFirstName);
      isValidString(accountOnwerLastName) &&
        setEditManagerLastName(accountOnwerLastName);
      isValidString(accountEmail) && setEditManagerEmail(accountEmail);
      isValidString(accountPhoneNumber) &&
        setEditManagerPhone(accountPhoneNumber);
      isValidString(contactCode) && setEditManagerCountryCode(contactCode);

      if (pic && pic.length > 0) {
        setEditUserProfilePic(IMAGE_URL + "server/" + pic[0]);
      }
    } else if (isRoleCarrier) {
      isValidString(contactPhone) && setUserPhone(contactPhone);
      isValidString(contactEmail) && setUserEmail(contactEmail);
      isValidString(companyName) && setCompanyName(companyName);
      isValidString(address) && setUserCompanyAddress(address);
      isValidString(DUNS) && setUserDuns(DUNS);
      isValidString(IBAN) && setUserIban(IBAN);
      isValidString(vat) && setUserVat(vat);
      isValidString(siret) && setUserSiret(siret);
      isValidString(BIC) && setUserBic(BIC);
      isValidString(CountryCode) && setUserCountryCode(CountryCode);
      isValidString(accountOwnerFirstName) &&
        setManageFirstrName(accountOwnerFirstName);
      isValidString(accountOwnerLastName) &&
        setManagerLastName(accountOwnerLastName);
      isValidString(accountOwnerEmail) && setManagerEmail(accountOwnerEmail);
      isValidString(accountNumber) && setUserAccountNumber(accountNumber);
      isValidString(accountOwnerPhoneNumber) &&
        setManagerPhone(accountOwnerPhoneNumber);
      isValidString(contactCode) && setManagerCountryCode(contactCode);
      if (pic && pic.length > 0) {
        setUserProfilePic(pic[0]);
      }

      // SET EDITED STATES
      isValidString(accountOnwerFirstName) &&
        setEditUserFirstName(accountOnwerFirstName);
      isValidString(accountOnwerLastName) &&
        setEditUserLastName(accountOnwerLastName);

      isValidString(contactPhone) && setEditUserPhone(contactPhone);
      isValidString(contactemail) && setEditUserEmail(contactemail);
      isValidString(companyName) && setEditCompanyName(companyName);
      isValidString(address) && setEditUserCompanyAddress(address);
      isValidString(DUNS) && setEditUserDuns(DUNS);
      isValidString(IBAN) && setEditUserIban(IBAN);
      isValidString(vat) && setEditUserVat(vat);
      isValidString(siret) && setEditUserSiret(siret);
      isValidString(BIC) && setEditUserBic(BIC);
      isValidString(CountryCode) && setEditUserCountryCode(CountryCode);
      isValidString(accountOwnerFirstName) &&
        setEditManageFirstrName(accountOwnerFirstName);
      isValidString(accountOwnerLastName) &&
        setEditManagerLastName(accountOwnerLastName);
      isValidString(accountOwnerEmail) &&
        setEditManagerEmail(accountOwnerEmail);
      isValidString(accountOwnerPhoneNumber) &&
        setEditManagerPhone(accountOwnerPhoneNumber);
      isValidString(contactCode) && setEditManagerCountryCode(contactCode);
      if (pic && pic.length > 0) {
        setEditUserProfilePic(IMAGE_URL + "server/" + pic[0]);
      }
    } else if (isRoleAdmin) {
      const accountOwnerFirstName = accountOnwerName
        ? accountOnwerName.split(" ")
        : ["N/A", ""];

      isValidString(phoneNumber) && setUserPhone(phoneNumber);
      isValidString(email) && setUserEmail(email);
      isValidString(companyName) && setCompanyName(companyName);
      isValidString(address) && setUserCompanyAddress(address);
      isValidString(paymentIBAN) && setUserIban(paymentIBAN);
      isValidString(duns) && setUserSiret(duns);
      isValidString(paymentBIC) && setUserBic(paymentBIC);
      isValidString(countryCode) && setUserCountryCode(countryCode);
      isValidString(accountOwnerFirstName[0]) &&
        setManageFirstrName(accountOwnerFirstName[0]);
      isValidString(accountOwnerFirstName[1]) &&
        setManagerLastName(accountOwnerFirstName[1]);
      isValidString(accountEmail) && setManagerEmail(accountEmail);
      isValidString(LoginId) && setUserAccountNumber(LoginId);
      isValidString(accountPhoneNumber) && setManagerPhone(accountPhoneNumber);
      isValidString(contactCode) && setManagerCountryCode(contactCode);
      isValidString(rcs) && setRcs(rcs);
      if (pic && pic.length > 0) {
        setUserProfilePic(pic[0]);
      }

      // SET EDITED STATES

      isValidString(phoneNumber) && setEditUserPhone(phoneNumber);
      isValidString(email) && setEditUserEmail(email);
      isValidString(companyName) && setEditCompanyName(companyName);
      isValidString(address) && setEditUserCompanyAddress(address);
      isValidString(paymentIBAN) && setEditUserIban(paymentIBAN);
      isValidString(duns) && setEditUserSiret(duns);
      isValidString(paymentBIC) && setEditUserBic(paymentBIC);
      isValidString(countryCode) && setEditUserCountryCode(countryCode);
      isValidString(accountOwnerFirstName[0]) &&
        setEditManageFirstrName(accountOwnerFirstName[0]);
      isValidString(accountOwnerFirstName[1]) &&
        setEditManagerLastName(accountOwnerFirstName[1]);
      isValidString(accountEmail) && setEditManagerEmail(accountEmail);
      isValidString(accountPhoneNumber) &&
        setEditManagerPhone(accountPhoneNumber);
      isValidString(contactCode) && setEditManagerCountryCode(contactCode);
      isValidString(rcs) && setEditRcs(rcs);
      if (pic && pic.length > 0) {
        setEditUserProfilePic(IMAGE_URL + "server/" + pic[0]);
      }
    } else if (isRoleClient) {
      isValidString(contactPhone) && setUserPhone(contactPhone);
      isValidString(contactEmail) && setUserEmail(contactEmail);
      isValidString(companyName) && setCompanyName(companyName);
      isValidString(address) && setUserCompanyAddress(address);
      isValidString(IBAN) && setUserIban(IBAN);
      isValidString(DUNS) && setUserSiret(DUNS);
      isValidString(BIC) && setUserBic(BIC);
      isValidString(accountOwnerCode) && setUserCountryCode(accountOwnerCode);
      isValidString(accountOwnerFirstName) &&
        setManageFirstrName(accountOwnerFirstName);
      isValidString(accountOwnerLastName) &&
        setManagerLastName(accountOwnerLastName);
      isValidString(accountOwnerEmail) && setManagerEmail(accountOwnerEmail);
      isValidString(accountNumber) && setUserAccountNumber(accountNumber);
      isValidString(accountOwnerPhoneNumber) &&
        setManagerPhone(accountOwnerPhoneNumber);
      isValidString(contactCode) && setManagerCountryCode(contactCode);
      if (pic && pic.length > 0) {
        setUserProfilePic(pic[0]);
      }

      // SET EDITED STATES

      isValidString(contactPhone) && setEditUserPhone(contactPhone);
      isValidString(contactEmail) && setEditUserEmail(contactEmail);
      isValidString(companyName) && setEditCompanyName(companyName);
      isValidString(address) && setEditUserCompanyAddress(address);
      isValidString(IBAN) && setEditUserIban(IBAN);
      isValidString(DUNS) && setEditUserSiret(DUNS);
      isValidString(BIC) && setEditUserBic(BIC);
      isValidString(accountOwnerCode) &&
        setEditUserCountryCode(accountOwnerCode);
      isValidString(accountOwnerFirstName) &&
        setEditManageFirstrName(accountOwnerFirstName);
      isValidString(accountOwnerLastName) &&
        setEditManagerLastName(accountOwnerLastName);
      isValidString(accountOwnerEmail) &&
        setEditManagerEmail(accountOwnerEmail);
      isValidString(accountOwnerPhoneNumber) &&
        setEditManagerPhone(accountOwnerPhoneNumber);
      isValidString(contactCode) && setEditManagerCountryCode(contactCode);
      if (pic && pic.length > 0) {
        setEditUserProfilePic(IMAGE_URL + "server/" + pic[0]);
      }
    } else if (isRoleStaff) {
      isValidString(firstName) && setUserFirstName(firstName);
      isValidString(lastName) && setUserLastName(lastName);
      isValidString(phoneNumber) && setUserPhone(phoneNumber);
      isValidString(email) && setUserEmail(email);
      isValidString(companyName) && setCompanyName(companyName);
      isValidString(address) && setUserCompanyAddress(address);
      isValidString(duns) && setUserDuns(duns);
      isValidString(paymentIBAN) && setUserIban(paymentIBAN);
      isValidString(duns) && setUserSiret(duns);
      isValidString(paymentBIC) && setUserBic(paymentBIC);
      isValidString(contactCode) && setUserCountryCode(contactCode);
      isValidString(accountOnwerName) && setManageFirstrName(accountOnwerName);
      isValidString(accountOnwerLastName) &&
        setManagerLastName(accountOnwerLastName);
      isValidString(mangerEmail) && setManagerEmail(mangerEmail);
      isValidString(accountNumber) && setUserAccountNumber(accountNumber);
      isValidString(accountPhoneNumber) && setManagerPhone(accountPhoneNumber);
      isValidString(accountOwnerCode) &&
        isValidString(Position) &&
        setManagerPosition(Position);
      isValidString(accountOwnerCode) &&
        setManagerCountryCode(accountOwnerCode);
      if (pic && pic.length > 0) {
        setUserProfilePic(pic[0]);
      }

      // SET EDITED STATES
      isValidString(firstName) && setEditUserFirstName(firstName);
      isValidString(lastName) && setEditUserLastName(lastName);

      isValidString(phoneNumber) && setEditUserPhone(phoneNumber);
      isValidString(email) && setEditUserEmail(email);
      isValidString(companyName) && setEditCompanyName(companyName);
      isValidString(address) && setEditUserCompanyAddress(address);
      isValidString(duns) && setEditUserDuns(duns);
      isValidString(paymentIBAN) && setEditUserIban(paymentIBAN);
      isValidString(duns) && setEditUserSiret(duns);
      isValidString(paymentBIC) && setEditUserBic(paymentBIC);
      isValidString(contactCode) && setEditUserCountryCode(contactCode);
      isValidString(accountOnwerName) &&
        setEditManageFirstrName(accountOnwerName);
      isValidString(accountOnwerLastName) &&
        setEditManagerLastName(accountOnwerLastName);
      isValidString(mangerEmail) && setEditManagerEmail(mangerEmail);
      isValidString(accountPhoneNumber) &&
        setEditManagerPhone(accountPhoneNumber);
      isValidString(accountOwnerCode) &&
        setEditManagerCountryCode(accountOwnerCode);
      if (pic && pic.length > 0) {
        setEditUserProfilePic(IMAGE_URL + "server/" + pic[0]);
      }
    }
  }, [userDetail]);

  const handlesetSelectedOption = () => {
    setSelectedOption(!selOption);
  };

  useEffect(() => {
    if (isRoleAdmin) {
      fetchAdminDetail();
    } else if (isRoleStaff) {
      fetchStaffDetail();
    } else {
      fetchUserDetail();
    }
  }, []);

  // Get Admin Data
  const fetchAdminDetail = () => {
    const payload = {
      adminId: userDetail._id,
    };

    // setIsLoading(true);
    getAdminDetail(payload)
      .then(async (res) => {
        if (res.status === true) {
          setAccountDetail(res.data);
          setImageSrc(res.data.pic[0]);
          if (res.data.pic && res.data.pic.length > 0) {
            setProfilePreview(BASE_URL + "server/" + res.data.pic[0]);
          }
          // setProfileImage(res.data);
          // await localStorage.setItem("IMAGEPROFILE", res.data.pic);
          await localStorage.setItem("userDetail", JSON.stringify(res.data));
        } else {
          toast(res.msg);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  // Get Staff Data
  const fetchStaffDetail = () => {
    const payload = {
      email: userDetail.email,
    };

    // setIsLoading(true);
    staff_PaticularDetail(payload)
      .then(async (res) => {
        if (res.status === true) {
          setAccountDetail(res.staffData);
          setImageSrc(res.staffData.pic[0]);
          if (res.staffData.pic && res.staffData.pic.length > 0) {
            setProfilePreview(BASE_URL + "server/" + res.staffData.pic[0]);
          }
          // setProfilePreview(res.staffData.pic[0]);
          // setProfileImage(res.staffData);
          await localStorage.setItem(
            "userDetail",
            JSON.stringify(res.staffData)
          );
        } else {
          toast(res.msg);
        }

        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  // Get User Data
  const fetchUserDetail = () => {
    const payload = {
      userId: userDetail._id,
      role: userRole,
    };

    // setIsLoading(true);
    user_Detail(payload)
      .then((res) => {
        setAccountDetail(res.data);
        setUserDetails({ ...res.data });
        const pic_array = res.data.pic;
        if (pic_array.length > 0) {
          setEditUserProfilePic(BASE_URL + "server/" + res.data.pic[0]);
          setUserProfilePic(BASE_URL + "server/" + res.data.pic[0]);
        }

        localStorage.setItem("userDetail", JSON.stringify(res.data));

        // setProfileImage(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const setProfileImage = (data) => {
    setProfilePreview(
      data.pic && data.pic.length > 0
        ? BASE_URL + "server/" + data.pic[0]
        : Logo
    );

    setImageSrc(
      data.pic && data.pic.length > 0
        ? BASE_URL + "server/" + data.pic[0]
        : imageSrc
    );
  };

  useEffect(() => {
    if (accountDetail) {
      setOwnerLastName(ownerLastName ? ownerLastName : lastName);
      setOwnerFirstName(ownerFirstName ? ownerFirstName : firstName);
      setPhone(phone_Number ? phone_Number : contactPhone);
      setContactEmail(email ? email : contactemail);
      setContactCompanyName(companyName);
      setCompanyDuns(duns);
      setCompanyAddress(address);
      setCompanyEmail(companyEmail);
      setAccountName(accountName ? accountName : accountOnwerName);
      setAccountOwnerPhone(accountPhoneNumber);
      setAccountOwnerEmail(accountEmail);
      setIban(paymentIBAN);
      setBic(paymentBIC);
      setSelectedCountryCode(contactCode);
      setUnLoadingCountryCode(accountOwnerCode);
      // getImage(pic)
    }
  }, [accountDetail, modalData]);

  const onSubmit = async (item) => {
    setSubmit(true);

    const isValid = onProfileValidation(item);

    if (!isValid) {
      if (errorCount > 0) {
        return;
      } else {
        setSubmit(false);
        handleEditButton(item);
      }
    }
  };

  const handleEditButton = (edit_type) => {
    editUserProfile(edit_type);
  };

  function setLoadingFun(loading_type, value) {
    if (loading_type == "CONTACT") {
      setEditContactLoading(value);
    } else if (loading_type == "COMPANY") {
      setEditCompanyLoading(value);
    } else if (loading_type == "PAYMENT") {
      setEditPaymentLoading(value);
    } else if (loading_type == "MANAGER") {
      setEditManagerLoading(value);
    }
  }

  const editUserProfile = (edit_type) => {
    const countryObject = phoneNumberCode.find((item) => item.code === country);
    const countryName = countryObject ? countryObject.name : undefined;
    const first_country_code = phoneNumberCode[0].code;

    console.log("countryName", countryName);

    const formData = new FormData();
    if (imageSrc) {
      formData.append("file", imageSrc);
    } else {
      formData.append("pic", user_profile_pic);
    }
    // if (imageSrc) formData.append("pic", imageSrc);
    formData.append("addid", userDetail._id);
    formData.append("firstName", edit_user_first_name);
    formData.append("lastName", edit_user_last_name);
    formData.append("Level", edit_company_name);
    formData.append("address", edit_user_company_address);
    formData.append("contactemail", edit_user_email);
    formData.append("contactPhone", edit_user_phone);
    formData.append("paymentIBAN", edit_user_iban);
    formData.append("paymentBIC", edit_user_bic);
    formData.append("vat", edit_user_vat);
    formData.append("countryISOCode", countyIsoCode);

    formData.append("countryName", countryNames);
    formData.append("countryCode", countrycode);
    formData.append("siret", edit_user_siret);
    formData.append("accountOwnerFirstName", edit_manager_first_name);
    formData.append("accountOwnerLastName", edit_manager_last_name);
    formData.append("accountOwnerPhoneNumber", edit_manager_phone);
    formData.append("accountOwnerEmail", edit_manager_email);
    formData.append(
      "contactCode",
      edit_manager_country_code ? edit_manager_country_code : first_country_code
    );
    formData.append("duns", edit_user_siret);
    formData.append("role", userRole);
    formData.append("rcs", edit_rcs);
    formData.append("vat_number", edit_user_vat);

    formData.append("contact_first_name", contactFirstName);
    formData.append("contact_last_name", contactLastName);

    setLoadingFun(edit_type, true);

    // setIsLoading(true);
    user_EditDetail(formData)
      .then((res) => {
        if (res.status === true) {
          toast("Account updated successfully!");
          fetchUserDetail();
          setLoadingFun(edit_type, false);
        } else toast(res.msg);
        setContactModal(false);
        setCompanyModal(false);
        setAccountModal(false);
        setPaymentModal(false);
        setLoadingFun(edit_type, false);
      })
      .catch((err) => {
        consoleService("error in user_edit_details_fun = ", err);
        setLoadingFun(edit_type, false);
      });
  };

  const onProfileValidation = (item) => {
    let errorCount = 0;

    if (isRoleUser) {
      if (item === "CONTACT" || item === undefined) {
        if (!contactFirstName || contactFirstName.trim().length === 0) {
          errorCount++;
          let msg = "Please enter first name.";
          setContactFirstNameError(msg);
        } else {
          setContactFirstNameError(null);
        }
        if (!country) {
          errorCount++;
          let msg = "Please select a country.";
          setCountryError(msg);
        } else {
          setCountryError(null);
        }

        if (!contactLastName || contactLastName.trim().length === 0) {
          errorCount++;
          let msg = "Please enter last name.";
          setContactLastNameError(msg);
        } else {
          setContactLastNameError(null);
        }

        if (!edit_user_phone) {
          errorCount++;
          let msg = "Please enter a valid number.";
          setPhoneError(msg);
        } else {
          setPhoneError(null);
        }

        let contactEmailError = SERVICE.validateEmail(edit_user_email);
        if (contactEmailError !== undefined) {
          errorCount++;
          let msg =
            contactEmailError === "required"
              ? "Please enter your email address."
              : "Please enter a valid email address.";

          setContactEmailError(msg);
        } else {
          setContactEmailError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item === "COMPANY" || item === undefined) {
        if (!edit_company_name) {
          errorCount++;
          let msg = "Please enter name.";
          setContactCompanyNameError(msg);
        } else {
          setContactCompanyNameError(null);
        }

        if (!edit_user_company_address) {
          errorCount++;
          let msg = "Please enter address.";
          setCompanyAddressError(msg);
        } else {
          setCompanyAddressError(null);
        }

        if (!edit_user_siret) {
          errorCount++;
          let msg = `Please Enter ${selOption ? "SIRET" : "DUNS"}.`;
          setUserSiretError(msg);
        } else {
          setUserSiretError(null);
        }

        // if (!edit_user_vat) {
        //   errorCount++;
        //   let msg = "Please enter VAT.";
        //   setUserVatError(msg);
        // } else {
        //   setUserVatError(null);
        // }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item === "ACCOUNT" || item === undefined) {
        if (!accountName) {
          errorCount++;
          let msg = "Please enter name.";
          setAccountNameError(msg);
        } else {
          setAccountNameError(null);
        }

        if (!country) {
          errorCount++;
          let msg = "Please select a country.";
          setCountryError(msg);
        } else {
          setCountryError(null);
        }

        if (!accountOwnerPhone) {
          errorCount++;
          let msg = "Please enter a valid number.";
          setAccountOwnerPhoneError(msg);
        } else {
          setAccountOwnerPhoneError(null);
        }

        let accountOwnerEmailError = SERVICE.validateEmail(AccountOwnerEmail);
        if (accountOwnerEmailError !== undefined) {
          errorCount++;
          let msg =
            AccountOwnerEmail === "required"
              ? "Please enter your email address."
              : "Please enter a valid email address.";
          setAccountOwnerEmailError(msg);
        } else {
          setAccountOwnerEmailError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item === "PAYMENT" || item === undefined) {
        if (!edit_user_iban) {
          errorCount++;
          let msg = "Please enter IBAN.";
          setIbanError(msg);
        } else {
          setIbanError(null);
        }
        if (!edit_user_bic) {
          errorCount++;
          let msg = "Please enter BIC.";
          setBicError(msg);
        } else {
          setBicError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }
    } else if (isRoleCarrier) {
      if (item === "MANAGER" || item === undefined) {
        if (!edit_manager_first_name) {
          errorCount++;
          let msg = "Please enter first name.";
          setUserFirstNameErr(msg);
        } else {
          setUserFirstNameErr(null);
        }

        if (!edit_manager_last_name) {
          errorCount++;
          let msg = "Please enter last name.";
          setUserLastNameErr(msg);
        } else {
          setUserLastNameErr(null);
        }

        if (!edit_manager_phone) {
          errorCount++;
          let msg = "Please enter a valid number.";
          setPhoneError(msg);
        } else {
          setPhoneError(null);
        }

        let contactEmailError = SERVICE.validateEmail(edit_manager_email);
        if (contactEmailError !== undefined) {
          errorCount++;
          let msg =
            contactEmailError === "required"
              ? "Please enter your email address."
              : "Please enter a valid email address.";

          setContactEmailError(msg);
        } else {
          setContactEmailError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }
      if (item === "CONTACT" || item === undefined) {
        if (!contactFirstName || contactFirstName.trim().length === 0) {
          errorCount++;
          let msg = "Please enter a valid firstname.";
          setContactFirstNameError(msg);
        } else {
          setContactFirstNameError(null);
        }

        if (!country) {
          errorCount++;
          let msg = "Please select a country.";
          setCountryError(msg);
        } else {
          setCountryError(null);
        }
        if (!contactLastName || contactLastName.trim().length === 0) {
          errorCount++;
          let msg = "Please enter a valid lastname.";
          setContactLastNameError(msg);
        } else {
          setContactLastNameError(null);
        }

        if (!edit_user_phone) {
          errorCount++;
          let msg = "Please enter a valid number.";
          setPhoneError(msg);
        } else {
          setPhoneError(null);
        }
        let contactEmailError = SERVICE.validateEmail(edit_user_email);
        if (contactEmailError !== undefined) {
          errorCount++;
          let msg =
            contactEmailError === "required"
              ? "Please enter your email address."
              : "Please enter a valid email address.";

          setContactEmailError(msg);
        } else {
          setContactEmailError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item === "COMPANY" || item === undefined) {
        if (!edit_company_name) {
          errorCount++;
          let msg = "Please enter name.";
          setContactCompanyNameError(msg);
        } else {
          setContactCompanyNameError(null);
        }

        if (!edit_user_company_address) {
          errorCount++;
          let msg = "Please enter address.";
          setCompanyAddressError(msg);
        } else {
          setCompanyAddressError(null);
        }

        if (!edit_user_siret) {
          errorCount++;
          let msg = `Please Enter ${selOption ? "SIRET" : "DUNS"}.`;
          setUserSiretError(msg);
        } else {
          setUserSiretError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item === "PAYMENT" || item === undefined) {
        if (!edit_user_iban) {
          errorCount++;
          let msg = "Please enter IBAN.";
          setIbanError(msg);
        } else {
          setIbanError(null);
        }
        if (!edit_user_bic) {
          errorCount++;
          let msg = "Please enter BIC.";
          setBicError(msg);
        } else {
          setBicError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }
    } else if (isRoleStaff) {
      if (item === "MANAGER" || item === undefined) {
        if (!edit_manager_first_name) {
          errorCount++;
          let msg = "Please enter first name.";
          setUserFirstNameErr(msg);
        } else {
          setUserFirstNameErr(null);
        }

        if (!edit_manager_last_name) {
          errorCount++;
          let msg = "Please enter last name.";
          setUserLastNameErr(msg);
        } else {
          setUserLastNameErr(null);
        }

        if (!edit_manager_phone) {
          errorCount++;
          let msg = "Please enter a valid number.";
          setPhoneError(msg);
        } else {
          setPhoneError(null);
        }

        let contactEmailError = SERVICE.validateEmail(edit_manager_email);
        if (contactEmailError !== undefined) {
          errorCount++;
          let msg =
            contactEmailError === "required"
              ? "Please enter your email address."
              : "Please enter a valid email address.";

          setContactEmailError(msg);
        } else {
          setContactEmailError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }
      if (item === "CONTACT" || item === undefined) {
        if (!edit_user_phone) {
          errorCount++;
          let msg = "Please enter a valid number.";
          setPhoneError(msg);
        } else {
          setPhoneError(null);
        }

        let contactEmailError = SERVICE.validateEmail(edit_user_email);
        if (contactEmailError !== undefined) {
          errorCount++;
          let msg =
            contactEmailError === "required"
              ? "Please enter your email address."
              : "Please enter a valid email address.";

          setContactEmailError(msg);
        } else {
          setContactEmailError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item === "COMPANY" || item === undefined) {
        if (!edit_company_name) {
          errorCount++;
          let msg = "Please enter name.";
          setContactCompanyNameError(msg);
        } else {
          setContactCompanyNameError(null);
        }

        if (!edit_user_company_address) {
          errorCount++;
          let msg = "Please enter address.";
          setCompanyAddressError(msg);
        } else {
          setCompanyAddressError(null);
        }

        if (!edit_user_siret) {
          errorCount++;
          let msg = `Please Enter ${selOption ? "SIRET" : "DUNS"}.`;
          setUserSiretError(msg);
        } else {
          setUserSiretError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item === "PAYMENT" || item === undefined) {
        if (!edit_user_iban) {
          errorCount++;
          let msg = "Please enter IBAN.";
          setIbanError(msg);
        } else {
          setIbanError(null);
        }
        if (!edit_user_bic) {
          errorCount++;
          let msg = "Please enter BIC.";
          setBicError(msg);
        } else {
          setBicError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }
    } else if (isRoleAdmin) {
      if (item === "MANAGER" || item === undefined) {
        if (!edit_manager_first_name) {
          errorCount++;
          let msg = "Please enter first name.";
          setUserFirstNameErr(msg);
        } else {
          setUserFirstNameErr(null);
        }

        if (!edit_manager_last_name) {
          errorCount++;
          let msg = "Please enter last name.";
          setUserLastNameErr(msg);
        } else {
          setUserLastNameErr(null);
        }

        if (!edit_manager_phone) {
          errorCount++;
          let msg = "Please enter a valid number.";
          setPhoneError(msg);
        } else {
          setPhoneError(null);
        }

        let contactEmailError = SERVICE.validateEmail(edit_manager_email);
        if (contactEmailError !== undefined) {
          errorCount++;
          let msg =
            contactEmailError === "required"
              ? "Please enter your email address."
              : "Please enter a valid email address.";

          setContactEmailError(msg);
        } else {
          setContactEmailError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }
      if (item === "CONTACT" || item === undefined) {
        if (!edit_user_phone) {
          errorCount++;
          let msg = "Please enter a valid number.";
          setPhoneError(msg);
        } else {
          setPhoneError(null);
        }

        let contactEmailError = SERVICE.validateEmail(edit_user_email);
        if (contactEmailError !== undefined) {
          errorCount++;
          let msg =
            contactEmailError === "required"
              ? "Please enter your email address."
              : "Please enter a valid email address.";

          setContactEmailError(msg);
        } else {
          setContactEmailError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item === "COMPANY" || item === undefined) {
        if (!edit_company_name) {
          errorCount++;
          let msg = "Please enter name.";
          setContactCompanyNameError(msg);
        } else {
          setContactCompanyNameError(null);
        }

        if (!edit_user_company_address) {
          errorCount++;
          let msg = "Please enter address.";
          setCompanyAddressError(msg);
        } else {
          setCompanyAddressError(null);
        }

        if (!edit_user_siret) {
          errorCount++;
          let msg = `Please Enter ${selOption ? "SIRET" : "DUNS"}.`;
          setUserSiretError(msg);
        } else {
          setUserSiretError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item === "PAYMENT" || item === undefined) {
        if (!edit_user_iban) {
          errorCount++;
          let msg = "Please enter IBAN.";
          setIbanError(msg);
        } else {
          setIbanError(null);
        }
        if (!edit_user_bic) {
          errorCount++;
          let msg = "Please enter BIC.";
          setBicError(msg);
        } else {
          setBicError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }
    } else if (isRoleClient) {
      if (item === "MANAGER" || item === undefined) {
        if (
          !edit_manager_first_name ||
          edit_manager_first_name.trim().length === 0
        ) {
          errorCount++;
          let msg = "Please enter first name.";
          setUserFirstNameErr(msg);
        } else {
          setUserFirstNameErr(null);
        }

        if (!country) {
          errorCount++;
          let msg = "Please select a country.";
          setCountryError(msg);
        } else {
          setCountryError(null);
        }

        if (
          !edit_manager_last_name ||
          edit_manager_last_name.trim().length === 0
        ) {
          errorCount++;
          let msg = "Please enter last name.";
          setUserLastNameErr(msg);
        } else {
          setUserLastNameErr(null);
        }

        if (!edit_manager_phone) {
          errorCount++;
          let msg = "Please enter a valid number.";
          setPhoneError(msg);
        } else {
          setPhoneError(null);
        }

        let contactEmailError = SERVICE.validateEmail(edit_manager_email);
        if (contactEmailError !== undefined) {
          errorCount++;
          let msg =
            contactEmailError === "required"
              ? "Please enter your email address."
              : "Please enter a valid email address.";

          setContactEmailError(msg);
        } else {
          setContactEmailError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }
      if (item === "CONTACT" || item === undefined) {
        if (!edit_user_phone) {
          errorCount++;
          let msg = "Please enter a valid number.";
          setPhoneError(msg);
        } else {
          setPhoneError(null);
        }

        if (!country) {
          errorCount++;
          let msg = "Please select a country.";
          setCountryError(msg);
        } else {
          setCountryError(null);
        }

        let contactEmailError = SERVICE.validateEmail(edit_user_email);
        if (contactEmailError !== undefined) {
          errorCount++;
          let msg =
            contactEmailError === "required"
              ? "Please enter your email address."
              : "Please enter a valid email address.";

          setContactEmailError(msg);
        } else {
          setContactEmailError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item === "COMPANY" || item === undefined) {
        if (!edit_company_name) {
          errorCount++;
          let msg = "Please enter name.";
          setContactCompanyNameError(msg);
        } else {
          setContactCompanyNameError(null);
        }

        if (!edit_user_company_address) {
          errorCount++;
          let msg = "Please enter address.";
          setCompanyAddressError(msg);
        } else {
          setCompanyAddressError(null);
        }

        if (!edit_user_siret) {
          errorCount++;
          let msg = `Please Enter ${selOption ? "SIRET" : "DUNS"}.`;
          setUserSiretError(msg);
        } else {
          setUserSiretError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item === "PAYMENT" || item === undefined) {
        if (!edit_user_iban) {
          errorCount++;
          let msg = "Please enter IBAN.";
          setIbanError(msg);
        } else {
          setIbanError(null);
        }
        if (!edit_user_bic) {
          errorCount++;
          let msg = "Please enter BIC.";
          setBicError(msg);
        } else {
          setBicError(null);
        }

        if (errorCount > 0) {
          return true;
        } else {
          return false;
        }
      }
    }

    if (errorCount > 0) return seterrCount(errorCount);
    else seterrCount(0);
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyB3cLetAkii900cvYPIrvxILEJ6qUhpG4I&libraries=places`;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setEditUserProfilePic(reader.result);
      setImageSrc(event.target.files[0]);
      setIsImage(true);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    getCounrtyCodeList();
  }, []);

  const getCounrtyCodeList = () => {
    const payload = {};
    country_PhoneNumberCode(payload).then((res) => {
      setPhoneNumberCode(res.data);
    });
  };

  function clear_edited_states() {
    setEditUserFirstName(user_first_name);
    setEditUserLastName(user_last_name);
    setEditUserPhone(user_phone);
    setEditUserEmail(user_email);
    setEditCompanyName(company_name);
    setEditUserDuns(user_duns);
    setEditUserCompanyAddress(user_company_address);
    setEditUserIban(user_iban);
    setEditUserVat(user_vat);
    setEditUserSiret(user_siret);
    setEditUserBic(user_bic);
    setEditUserCountryCode(user_country_code);

    if (userRole == "User") {
      setEditManageFirstrName(accountOnwerFirstName);
      setEditManagerLastName(accountOnwerLastName);
      setEditManagerEmail(accountEmail);
      setEditManagerPhone(accountPhoneNumber);
      setEditManagerCountryCode(contactCode);
    } else {
      setEditManageFirstrName(accountOwnerFirstName);
      setEditManagerLastName(accountOwnerLastName);
      setEditManagerEmail(accountOwnerEmail);
      setEditManagerPhone(accountOwnerPhoneNumber);
      setEditManagerCountryCode(contactCode);
    }
    if (user_profile_pic) {
      setEditUserProfilePic(BASE_URL + "server/" + user_profile_pic);
    }

    setImageSrc("");
  }

  useEffect(() => {
    if (userDetail?.country) {
      const data = phoneNumberCode.find(
        (item) => item.name === userDetail.country
      );
      const countryCode = data ? data.code : undefined;
      setCountry(countryCode);
      // setCountry(userDetail.country);
    }
  }, [phoneNumberCode, userDetail]);

  const handleCounty = (e) => {
    const selectedCode = e.target.value;
    console.log("selectedCode", e.target.value);
    setCountry(selectedCode);

    const selectedCountry = phoneNumberCode.find(
      (option) => option.code === selectedCode
    );
    console.log("selectedCountry", selectedCountry);
    if (selectedCountry) {
      setCountyIsoCode(selectedCountry.code);
      setCountryNames(selectedCountry.name);
      setCountrycode(selectedCountry.code);
    }
  };
  useEffect(() => {
    if (CountryCode && phoneNumberCode?.length) {
      const matchedCountry = phoneNumberCode.find(
        (item) => item.code === CountryCode
      );
      if (matchedCountry) {
        setCountry(matchedCountry.code);
      }
    }
  }, [CountryCode, phoneNumberCode]);

  //
  const [carriers, setCarriers] = useState([{ id: Date.now(), value: "" }]);

  const [preferredCarriers, setPreferredCarriers] = useState([]); // {account_number, carrierId, isValid, error}
  const [isLoadingCarriers, setIsLoadingCarriers] = useState(false);
  const [isSavingCarriers, setIsSavingCarriers] = useState(false);
  const [isRemovingCarriers, setIsRemovingCarriers] = useState(false);

  const [fetchedPreferredCarriers, setFetchedPreferredCarriers] = useState([]);
  const [isLoadingFetchedCarriers, setIsLoadingFetchedCarriers] =
    useState(false);
  const [checkcarrierloading, setCheckcarrierloading] = useState(false);

  const handleOpenPreferredCarriers = async () => {
    setPreferredCarriersModal(true);
    setIsLoadingCarriers(true);
    try {
      const res = await get_carrier_preference({ userId: userDetail._id });
      console.log("res", res);
      if (res.status && Array.isArray(res.data)) {
        setPreferredCarriers(
          res.data.map((item) => ({
            account_number: item.accountNumber,
            carrierId: item.carrierInfo?._id,
            isValid: true,
            error: "",
            carrierInfo: item.carrierInfo?.companyName,
          }))
        );
      } else {
        setPreferredCarriers([]);
      }
    } catch {
      setPreferredCarriers([]);
    }
    setIsLoadingCarriers(false);
  };

  useEffect(() => {
    if (userDetail?._id) {
      setIsLoadingFetchedCarriers(true);
      get_carrier_preference({ userId: userDetail._id })
        .then((res) => {
          console.log("res", res);
          if (res.status && Array.isArray(res.data)) {
            setFetchedPreferredCarriers(
              res.data.map((item) => ({
                account_number: item.accountNumber,
                carrierId: item.carrierInfo?._id,
                isValid: true,
                error: "",
                carrierInfo: item.carrierInfo?.companyName,
              }))
            );
          } else {
            setFetchedPreferredCarriers([]);
          }
          setIsLoadingFetchedCarriers(false);
          console.log("res", res);
        })
        .catch(() => {
          setFetchedPreferredCarriers([]);
          setIsLoadingFetchedCarriers(false);
        });
    }
  }, [
    userDetail?._id,
    isSavingCarriers,
    isRemovingCarriers,
    showPreferredCarriers,
  ]);

  const handleCarrierInputChange = async (index, value) => {
    setPreferredCarriers((prev) =>
      prev.map((c, i) =>
        i === index
          ? { ...c, account_number: value, isValid: false, error: "" }
          : c
      )
    );

    if (value.trim().length === 0) {
      setPreferredCarriers((prev) =>
        prev.map((c, i) =>
          i === index ? { ...c, isValid: false, error: "" } : c
        )
      );
      return;
    }

    // Check for duplicate account numbers
    const isDuplicate = preferredCarriers.some(
      (carrier, i) => i !== index && carrier.account_number === value.trim()
    );

    if (isDuplicate) {
      setPreferredCarriers((prev) =>
        prev.map((c, i) =>
          i === index
            ? {
                ...c,
                isValid: false,
                error: "This account number is already added",
              }
            : c
        )
      );
      return;
    }

    if (value.trim().length > 7) {
      try {
        setCheckcarrierloading(true);
        const res = await checkCarrierValidation({ accountNumber: value });
        console.log("res", res);
        if (res?.status == 1) {
          setPreferredCarriers((prev) =>
            prev.map((c, i) =>
              i === index
                ? {
                    ...c,
                    carrierId: res.data._id,
                    isValid: true,
                    error: "",
                  }
                : c
            )
          );
        } else {
          setPreferredCarriers((prev) =>
            prev.map((c, i) =>
              i === index
                ? { ...c, isValid: false, error: "Invalid number" }
                : c
            )
          );
        }
      } catch {
        setPreferredCarriers((prev) =>
          prev.map((c, i) =>
            i === index ? { ...c, isValid: false, error: "Invalid number" } : c
          )
        );
      }
      setCheckcarrierloading(false);
    } else {
      setPreferredCarriers((prev) =>
        prev.map((c, i) =>
          i === index ? { ...c, isValid: false, error: "" } : c
        )
      );
    }
  };

  const handleAddCarrier = async (index) => {
    console.log("handleAddCarrier", index);
    const carrier = preferredCarriers[index];
    if (!carrier.account_number.trim()) {
      setPreferredCarriers((prev) =>
        prev.map((c, i) =>
          i === index ? { ...c, isValid: false, error: "Required" } : c
        )
      );
      return;
    }
    setIsLoadingCarriers(true);
    try {
      const res = await checkCarrierValidation({
        account_number: carrier.account_number,
      });
      if (res?.data?.success) {
        setPreferredCarriers((prev) =>
          prev.map((c, i) =>
            i === index
              ? {
                  ...c,
                  carrierId: res.data.data._id,
                  isValid: true,
                  error: "",
                }
              : c
          )
        );
      } else {
        setPreferredCarriers((prev) =>
          prev.map((c, i) =>
            i === index ? { ...c, isValid: false, error: "Invalid number" } : c
          )
        );
      }
    } catch {
      setPreferredCarriers((prev) =>
        prev.map((c, i) =>
          i === index ? { ...c, isValid: false, error: "Invalid number" } : c
        )
      );
    }
    setIsLoadingCarriers(false);
  };
  console.log("preferredCarriers", preferredCarriers);

  const handleAddNewCarrierField = () => {
    setPreferredCarriers((prev) => [
      ...prev,
      { account_number: "", carrierId: null, isValid: false, error: "" },
    ]);
  };

  const handleRemoveCarrier = (index) => {
    setPreferredCarriers((prev) => prev.filter((_, i) => i !== index));
    setIsRemovingCarriers(true);
  };

  const handleSavePreferredCarriers = async () => {
    // Validate all
    let hasInvalid = false;

    // Check for duplicates
    const accountNumbers = preferredCarriers
      .map((c) => c.account_number.trim())
      .filter((num) => num !== "");
    const duplicates = accountNumbers.filter(
      (num, index) => accountNumbers.indexOf(num) !== index
    );
    console.log("duplicates", duplicates);

    if (duplicates.length > 0) {
      toast(
        "Duplicate account numbers found. Please remove duplicates before saving."
      );
      return;
    }

    // If preferredCarriers is empty, call remove_carrier_preference
    if (preferredCarriers.length === 0) {
      setIsSavingCarriers(true);
      try {
        const res = await remove_carrier_preference({ userId: userDetail._id });
        if (res.status) {
          setPreferredCarriersModal(false);
        } else {
          toast(res.msg || "Failed to remove preferred carriers.");
        }
      } catch {
        toast("Failed to remove preferred carriers.");
      }
      setIsSavingCarriers(false);
      return;
    }

    preferredCarriers.forEach((c, i) => {
      if (!c.isValid || !c.carrierId) {
        hasInvalid = true;
        setPreferredCarriers((prev) =>
          prev.map((item, idx) =>
            idx === i
              ? {
                  ...item,
                  isValid: false,
                  error: item.error || "Please enter a valid number",
                }
              : item
          )
        );
      }
    });
    console.log("hasInvalid", hasInvalid);
    if (hasInvalid) return;

    setIsSavingCarriers(true);
    try {
      // Build array of { userId, carrierId }
      const carrierArray = preferredCarriers.map((c) => ({
        userId: userDetail._id,
        carrierId: c.carrierId,
      }));

      // Send this array to your API
      const res = await add_carrier_preference({ carriers: carrierArray });

      if (res.status) {
        toast("Preferred carriers updated!");
        setPreferredCarriersModal(false);
        // Optionally refresh list
      } else {
        toast(res.msg || "Failed to save.");
      }
    } catch {
      toast("Failed to save.");
    }
    setIsSavingCarriers(false);
  };

  console.log("preferredCarriers", preferredCarriers);

  const handleEnablePreferredCarriers = async (status) => {
    // status is true if checked, false if unchecked
    setShowPreferredCarriers(status);
    try {
      const res = await enable_preferred_carriers({
        userId: userDetail._id,
        status: status,
      });
      console.log("API response:", res);
      // Optionally handle API response or errors here
    } catch (error) {
      console.error("API error:", error);
      // Optionally revert UI if API fails
      setShowPreferredCarriers(!status);
    }
  };

  console.log("prefferedCarrierToggle", prefferedCarrierToggle);

  return (
    <React.Fragment>
      <div className="d-flex" id="wrapper">
        <SideBar />
        <div id="page-content-wrapper">
          <NavBar />

          {/* CONTAINER FOR ADMIN ROLE  */}

          {isRoleAdmin && (
            <Container fluid className="pt-120">
              <div className="quotes_div accountBox">
                <Row>
                  <Col lg={5} md={6}>
                    <div className="account_box ">
                      <div className="userInfo">
                        {user_profile_pic && user_profile_pic.length > 0 ? (
                          <Image
                            className="logo ms-3"
                            src={IMAGE_URL + "server/" + user_profile_pic}
                            alt=""
                          />
                        ) : (
                          <HiUser size={100} />
                        )}

                        <div className="uspad">
                          <h1>{company_name}</h1>

                          <h3>{user_account_number}</h3>
                        </div>
                        <div className="langDiv">
                          <Select
                            defaultValue={options[0]}
                            onChange={handlesetSelectedOption}
                            options={options}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={7} md={6}>
                    <div className="braedContact ">
                      <Image className="tIcon" src={MessageIcon2} alt=""  height={22} width={22}/>
                      <h3>CONTACT</h3>

                      <Link
                        onClick={() => {
                          setContactModal(true);
                          setModalData({
                            phone: user_phone,
                            code: user_country_code,
                            email: user_email,
                            selectedCountryCode: selectedCountryCode,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link>
                    </div>
                    <div class="account_body braedContactFull braedContactFull1">
                      <div>
                        <h3>Phone</h3>
                        <h4>
                          {" "}
                          {user_phone && user_country_code
                            ? `${user_country_code} ${user_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Email</h3>
                        <h4>{user_email ? user_email : "N/A"}</h4>
                      </div>
                      {/* <div className="account_mleft">
                        <h3>Country</h3>
                        <h4>{userDetail ? userDetail?.countryName : "N/A"}</h4>
                      </div> */}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={BuildingIcon2} alt=""  height={22} width={22}/>
                      <h3>COMPANY</h3>

                      <Link
                        onClick={() => {
                          setCompanyModal(true);
                          setModalData({
                            Name: company_name,
                            DUNS: duns,
                            Address: user_company_address,
                            SIRET: user_siret,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link>
                    </div>
                    <div class="account_body braedContactFull1">
                      <div>
                        <h3>Name</h3>
                        <h4>{company_name ? company_name : "N/A"}</h4>
                      </div>

                      <div className="account_mleft">
                        {/* <h3>{selOption ? "SIRET" : "DUNS"}</h3> */}
                        <h3>{"DUNS"}</h3>

                        {/* <h4>{user_siret ? user_siret : "N/A"}</h4> */}
                        <h4>{duns ? duns : "N/A"}</h4>
                      </div>
                      <div>
                        <h3>RCS</h3>
                        <h4>{rcs ? rcs : "N/A"}</h4>
                      </div>
                      <div>
                        <h3>VAT number</h3>
                        <h4>{vat_number ? vat_number : "N/A"}</h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Address</h3>
                        <h4>
                          {user_company_address ? user_company_address : "N/A"}
                        </h4>
                      </div>

                      {/* <div className="account_mleft">
                  <h3>VAT</h3>
                  <h4>{user_vat ? user_vat : "N/A"}</h4>
                </div> */}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} md={6}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={UserSquare} alt=""  height={22} width={22}/>
                      <h3>Account Owner</h3>
                      <Link
                        onClick={() => {
                          setAccountModal(true);
                          setModalData({
                            Name: accountName ? accountName : accountOnwerName,
                            Phone: accountPhoneNumber,
                            Email: accountEmail,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link>
                    </div>
                    <div class="account_body account_bodyPad  braedContactFull1">
                      <div>
                        <h3>First Name</h3>
                        <h4>
                          {manager_first_name ? `${manager_first_name}` : "N/A"}
                        </h4>
                      </div>

                      <div className="account_mleft" style={{ paddingLeft: 0 }}>
                        <h3>Last Name</h3>
                        <h4>
                          {manager_last_name ? `${manager_last_name}` : "N/A"}
                        </h4>
                      </div>
                      <div>
                        <h3>Phone</h3>
                        <h4 style={{ minWidth: "115px" }}>
                          {manager_phone && manager_country_code
                            ? `${manager_country_code} ${manager_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Email</h3>
                        <h4>{manager_email ? manager_email : "N/A"}</h4>
                      </div>
                    </div>
                    {/* <div class="account_body align-items-start">
                      <div>
                        <h3>Name</h3>
                        <h4>
                          {manager_last_name
                            ? `${manager_last_name} ${manager_first_name}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Phone</h3>
                        <h4>
                          {manager_phone && manager_country_code
                            ? `${manager_country_code} ${manager_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Email</h3>
                        <h4>{manager_email ? manager_email : "N/A"}</h4>
                      </div>
                    </div> */}
                  </Col>
                  <Col lg={6} md={6}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={PaymentIcon2} alt="" />
                      <h3>PAYMENT </h3>
                      <Link
                        onClick={() => {
                          setPaymentModal(true);
                          setModalData({
                            iban: user_iban,
                            bic: user_bic,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link>
                    </div>

                    <div class="account_body braedContactFull1">
                      <div>
                        <h3>IBAN</h3>
                        <h4 className="mb-1">
                          {user_iban ? user_iban : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>BIC</h3>
                        <h4> {user_bic ? user_bic : "N/A"}</h4>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          )}

          {/* CONTAINER FOR STAFF ROLE */}
          {isRoleStaff && (
            <Container fluid className="pt-120">
              <div className="quotes_div accountBox">
                <Row>
                  <Col lg={5} md={6}>
                    <div className="account_box">
                      <div className="userInfo">
                        {user_profile_pic && user_profile_pic.length > 0 ? (
                          <Image
                            className="logo ms-3"
                            src={IMAGE_URL + "server/" + user_profile_pic}
                            alt=""
                          />
                        ) : (
                          <HiUser size={100} />
                        )}

                        <div className="uspad">
                          <h1>{`${user_first_name} ${user_last_name}`}</h1>
                          <h3>{`${Position}`}</h3>

                          <h3>{user_account_number}</h3>
                        </div>
                        <div className="langDiv">
                          <Select
                            defaultValue={options[0]}
                            onChange={handlesetSelectedOption}
                            options={options}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={7} md={6}>
                    <div className="braedContact">
                      <Image className="tIcon" src={MessageIcon2} alt=""  height={22} width={22}/>
                      <h3>CONTACT</h3>

                      {/* <Link
                        onClick={() => {
                          setContactModal(true);
                          setModalData({
                            phone: user_phone,
                            code: user_country_code,
                            email: user_email,
                            selectedCountryCode: selectedCountryCode,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link> */}
                    </div>
                    <div class="account_body braedContactFull braedContactFull1">
                      <div>
                        <h3>Phone</h3>
                        <h4>
                          {user_phone && user_country_code
                            ? `${user_country_code} ${user_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Email</h3>
                        <h4>{user_email ? user_email : "N/A"}</h4>
                      </div>
                      {/* <div className="account_mleft">
                        <h3>Country</h3>
                        <h4>{userDetail ? userDetail?.countryName : "N/A"}</h4>
                      </div> */}
                    </div>
                  </Col>
                </Row>
                {userRole != "Staff" && (
                  <Row>
                    <Col lg={12} md={12}>
                      <div className="braedContact mt-4">
                        <Image className="tIcon" src={BuildingIcon2} alt=""  height={22} width={22}/>
                        <h3>COMPANY</h3>

                        <Link
                          onClick={() => {
                            setCompanyModal(true);
                            setModalData({
                              Name: company_name,
                              DUNS: duns,
                              Address: user_company_address,
                              SIRET: user_siret,
                            });
                          }}
                        >
                          <Image className="tIcon" src={EditIcon2} alt="" />
                        </Link>
                      </div>
                      <div class="account_body">
                        <div>
                          <h3>Name</h3>
                          <h4>{company_name}</h4>
                        </div>

                        <div className="account_mleft">
                          {/* <h3>{selOption ? "SIRET" : "DUNS"}</h3> */}
                          <h3>{"DUNS"}</h3>

                          {/* <h4>{user_siret ? user_siret : "N/A"}</h4> */}
                          <h4>{duns ? duns : "N/A"}</h4>
                        </div>
                        <div className="account_mleft">
                          <h3>Address</h3>
                          <h4>
                            {user_company_address
                              ? user_company_address
                              : "N/A"}
                          </h4>
                        </div>

                        {/* <div className="account_mleft">
                  <h3>VAT</h3>
                  <h4>{user_vat ? user_vat : "N/A"}</h4>
                </div> */}
                      </div>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col lg={12} md={12}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={UserSquare} alt=""  height={22} width={22}/>
                      <h3>MANAGER</h3>
                      {/* <Link
                        onClick={() => {
                          setAccountModal(true);
                          setModalData({
                            Name: accountName ? accountName : accountOnwerName,
                            Phone: accountPhoneNumber,
                            Email: accountEmail,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link> */}
                    </div>
                    <div class="account_body account_bodyPad braedContactFull2">
                      <div>
                        <h3>First Name</h3>
                        <h4>
                          {manager_first_name ? `${manager_first_name}` : "N/A"}
                        </h4>
                      </div>

                      <div className="account_mleft">
                        <h3>Last Name</h3>
                        <h4>
                          {manager_last_name ? `${manager_last_name}` : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Phone</h3>
                        <h4>
                          {manager_phone && manager_country_code
                            ? `${manager_country_code} ${manager_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Email</h3>
                        <h4>{manager_email ? manager_email : "N/A"}</h4>
                      </div>
                    </div>
                    {/* <div class="account_body braedContactFull">
                      <div>
                        <h3>Name</h3>
                        <h4>
                          {manager_last_name
                            ? `${manager_last_name} ${manager_first_name}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Phone</h3>
                        <h4>
                          {manager_phone && manager_country_code
                            ? `${manager_country_code} ${manager_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Email</h3>
                        <h4>{manager_email ? manager_email : "N/A"}</h4>
                      </div>
                    </div> */}
                  </Col>
                  {userRole != "Staff" && (
                    <Col lg={6} md={6}>
                      <div className="braedContact mt-4">
                        <Image className="tIcon" src={PaymentIcon2} alt="" />
                        <h3>PAYMENT </h3>
                        {/* <Link
                        onClick={() => {
                          setPaymentModal(true);
                          setModalData({
                            iban: user_iban,
                            bic: user_bic,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link> */}
                      </div>

                      <div class="account_body">
                        <div>
                          <h3>IBAN</h3>
                          <h4 className="mb-1">
                            {user_iban ? user_iban : "N/A"}
                          </h4>
                        </div>
                        <div className="account_mleft">
                          <h3>BIC</h3>
                          <h4> {user_bic ? user_bic : "N/A"}</h4>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </Container>
          )}

          {/* CONTAINER FOR USER ROLE */}
          {isRoleUser && (
            <Container fluid className="pt-120">
              <div className="quotes_div accountBox">
                <Row>
                  <Col lg={5} md={6}>
                    <div className="account_box">
                      <div className="userInfo">
                        {user_profile_pic && user_profile_pic.length > 0 ? (
                          <Image
                            className="logo ms-3"
                            src={IMAGE_URL + "server/" + user_profile_pic}
                            alt=""
                          />
                        ) : (
                          <HiUser size={100} />
                        )}

                        <div className="uspad">
                          <h1>
                            {[contact_first_name, " ", contact_last_name]}
                          </h1>

                          <h3>{user_account_number}</h3>
                        </div>
                        <div className="langDiv">
                          <Select
                            defaultValue={options[0]}
                            onChange={handlesetSelectedOption}
                            options={options}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={7} md={6}>
                    <div className="braedContact ">
                      <Image className="tIcon" src={MessageIcon2} alt=""  height={22} width={22}/>
                      <h3>CONTACT</h3>

                      <Link
                        onClick={() => {
                          setContactModal(true);
                          setModalData({
                            phone: user_phone,
                            code: user_country_code,
                            email: user_email,
                            selectedCountryCode: selectedCountryCode,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link>
                    </div>
                    <div class="account_body  braedContactFull1">
                      <div>
                        <h3>Phone</h3>
                        <h4>{`${user_country_code} ${user_phone}`}</h4>
                      </div>
                      <div >
                        <h3>Email</h3>
                        <h4>{user_email}</h4>
                      </div>
                      <div >
                        <h3>Country</h3>
                        <h4>{userDetail ? userDetail?.countryName : "N/A"}</h4>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={BuildingIcon2} alt=""  height={22} width={22}/>
                      <h3>COMPANY</h3>

                      {/* <Link
                        onClick={() => {
                          setCompanyModal(true);
                          setModalData({
                            Name: company_name,
                            DUNS: duns,
                            Address: user_company_address,
                            SIRET: user_siret,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link> */}
                    </div>
                    <div class="account_body braedContactFull">
                      <div>
                        <h3>Name</h3>
                        <h4>{company_name}</h4>
                      </div>

                      <div className="account_mleft">
                        {/* <h3>{selOption ? "SIRET" : "DUNS"}</h3> */}
                        <h3>{"DUNS"}</h3>

                        <h4>{duns ? duns : "N/A"}</h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Address</h3>
                        <h4>
                          {user_company_address ? user_company_address : "N/A"}
                        </h4>
                      </div>

                      {/* <div className="account_mleft">
                     <h3>VAT</h3>
                     <h4>{user_vat ? user_vat : "N/A"}</h4>
                   </div> */}
                    </div>
                  </Col>
                  <Col lg={12} md={12}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={UserSquare} alt=""  height={22} width={22}/>
                      <h3 className="text-uppercase">Account Owner</h3>
                      {/* <Link>
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link> */}
                      <Link
                        onClick={() => {
                          setAccountModal(true);
                          setModalData({
                            Name: accountName ? accountName : accountOnwerName,
                            Phone: accountPhoneNumber,
                            Email: accountEmail,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link>
                    </div>
                    <div class="account_body braedContactFull1">
                      <div className="braedContactFull1">
                        <h3>First Name</h3>
                        <h4>
                          {manager_first_name ? `${manager_first_name}` : "N/A"}
                        </h4>
                      </div>

                      <div className=" braedContactFull1">
                        <h3>Last Name</h3>
                        <h4>
                          {manager_last_name ? `${manager_last_name}` : "N/A"}
                        </h4>
                      </div>
                      <div className=" braedContactFull1" >
                        <h3>Phone</h3>
                        {console.log(
                          "manager_country_code",
                          `${manager_country_code} ${manager_phone}`
                        )}
                        <h4>
                          {manager_phone && manager_country_code
                            ? `${manager_country_code} ${manager_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="">
                        <h3>Email</h3>
                        <h4>{manager_email ? manager_email : "N/A"}</h4>
                      </div>
                    </div>
                  </Col>
                  {/* <Col lg={6} md={6}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={PaymentIcon2} alt="" />
                      <h3>PAYMENT </h3>
                    
                    </div>

                    <div class="account_body">
                      <div>
                        <h3>IBAN</h3>
                        <h4 className="mb-1">
                          {user_iban ? user_iban : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>BIC</h3>
                        <h4> {user_bic ? user_bic : "N/A"}</h4>
                      </div>
                    </div>
                  </Col> */}
                </Row>

                <Row>
                  <Col lg={12}>
                    <div className="braedContact mt-4">
                    <svg width="25" height="24" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5991 15.9423H2.97836C2.54522 15.9423 2.18604 15.5831 2.18604 15.15V6.69857C2.18604 3.93073 4.43622 1.68054 7.20406 1.68054H16.7119C17.145 1.68054 17.5042 2.03973 17.5042 2.47286V13.0371C17.5042 14.6429 16.2048 15.9423 14.5991 15.9423ZM3.77068 14.3577H14.5991C15.328 14.3577 15.9196 13.7661 15.9196 13.0371V3.26518H7.20406C5.31306 3.26518 3.77068 4.80757 3.77068 6.69857V14.3577Z" fill="#4F5B92"/>
<path d="M20.9376 22.2809H19.8812C19.448 22.2809 19.0889 21.9217 19.0889 21.4886C19.0889 20.7596 18.4973 20.168 17.7683 20.168C17.0394 20.168 16.4478 20.7596 16.4478 21.4886C16.4478 21.9217 16.0886 22.2809 15.6555 22.2809H11.4298C10.9966 22.2809 10.6375 21.9217 10.6375 21.4886C10.6375 20.7596 10.0459 20.168 9.31692 20.168C8.58798 20.168 7.99638 20.7596 7.99638 21.4886C7.99638 21.9217 7.6372 22.2809 7.20406 22.2809H6.14764C3.96083 22.2809 2.18604 20.5061 2.18604 18.3193V15.15C2.18604 14.7169 2.54522 14.3577 2.97836 14.3577H14.5991C15.328 14.3577 15.9196 13.7661 15.9196 13.0372V5.64217C15.9196 5.20904 16.2788 4.84985 16.7119 4.84985H18.6557C19.7016 4.84985 20.663 5.40978 21.1806 6.3183L22.9871 9.47701C23.1244 9.71999 23.1244 10.0264 22.9871 10.2693C22.8497 10.5123 22.5856 10.6602 22.3004 10.6602H20.9376C20.7897 10.6602 20.6735 10.7764 20.6735 10.9243V14.0936C20.6735 14.2415 20.7897 14.3577 20.9376 14.3577H24.1069C24.54 14.3577 24.8992 14.7169 24.8992 15.15V18.3193C24.8992 20.5061 23.1244 22.2809 20.9376 22.2809ZM20.5679 20.6963H20.9376C22.2476 20.6963 23.3146 19.6293 23.3146 18.3193V15.9423H20.9376C19.9234 15.9423 19.0889 15.1078 19.0889 14.0936V10.9243C19.0889 9.91014 19.9129 9.07556 20.9376 9.07556L19.8072 7.10005C19.5748 6.68804 19.1311 6.43449 18.6557 6.43449H17.5042V13.0372C17.5042 14.6429 16.2048 15.9423 14.5991 15.9423H3.77068V18.3193C3.77068 19.6293 4.83767 20.6963 6.14764 20.6963H6.51739C6.86601 19.4814 7.98582 18.5834 9.31692 18.5834C10.648 18.5834 11.7678 19.4814 12.1164 20.6963H14.9793C15.328 19.4814 16.4478 18.5834 17.7789 18.5834C19.11 18.5834 20.2192 19.4814 20.5679 20.6963Z" fill="#4F5B92"/>
<path d="M9.31728 24.3937C7.71151 24.3937 6.41211 23.0943 6.41211 21.4885C6.41211 19.8828 7.71151 18.5834 9.31728 18.5834C10.9231 18.5834 12.2225 19.8828 12.2225 21.4885C12.2225 23.0943 10.9231 24.3937 9.31728 24.3937ZM9.31728 20.168C8.58835 20.168 7.99675 20.7596 7.99675 21.4885C7.99675 22.2175 8.58835 22.8091 9.31728 22.8091C10.0462 22.8091 10.6378 22.2175 10.6378 21.4885C10.6378 20.7596 10.0462 20.168 9.31728 20.168Z" fill="#4F5B92"/>
<path d="M17.7685 24.3937C16.1627 24.3937 14.8633 23.0943 14.8633 21.4885C14.8633 19.8828 16.1627 18.5834 17.7685 18.5834C19.3742 18.5834 20.6736 19.8828 20.6736 21.4885C20.6736 23.0943 19.3742 24.3937 17.7685 24.3937ZM17.7685 20.168C17.0395 20.168 16.4479 20.7596 16.4479 21.4885C16.4479 22.2175 17.0395 22.8091 17.7685 22.8091C18.4974 22.8091 19.089 22.2175 19.089 21.4885C19.089 20.7596 18.4974 20.168 17.7685 20.168Z" fill="#4F5B92"/>
<path d="M24.1069 15.9423H20.9376C19.9234 15.9423 19.0889 15.1078 19.0889 14.0936V10.9243C19.0889 9.91014 19.9234 9.07556 20.9376 9.07556H22.3004C22.5856 9.07556 22.8497 9.22347 22.9871 9.47701L24.7936 12.6463C24.857 12.7625 24.8992 12.8998 24.8992 13.0372V15.15C24.8992 15.5832 24.54 15.9423 24.1069 15.9423ZM20.9376 10.6602C20.7897 10.6602 20.6735 10.7764 20.6735 10.9243V14.0936C20.6735 14.2415 20.7897 14.3577 20.9376 14.3577H23.3146V13.2485L21.8356 10.6602H20.9376Z" fill="#4F5B92"/>
</svg>

                      <h3 style={{letterSpacing:'0.03em'}}>PREFERRED CARRIERS</h3>
                      {/* <Link>
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link> */}
                      <Link
                        onClick={() => {
                          handleOpenPreferredCarriers();
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link>
                    </div>
                    <div className="mt-3 d-flex align-items-center gap-1">
                      <Form.Check
                        type="checkbox"
                        id="preferred-carriers-toggle"
                        checked={showPreferredCarriers}
                        onChange={async (e) => {
                          const checked = e.target.checked;
                          setShowPreferredCarriers(checked); // update UI immediately
                          await handleEnablePreferredCarriers(checked); // send to API
                        }}
                        style={{
                          fontSize: "14px",
                          color: "#4f5b92",
                        }}
                        label={
                          showPreferredCarriers
                            ? "Disable preferred carriers"
                            : "Enable preferred carriers"
                        }
                      />

                      {["top"].map((placement) => (
                        <OverlayTrigger
                          key={placement}
                          placement={placement}
                          overlay={
                            <Tooltip id={`tooltip-${placement}`}>
                              Note: The preferred carriers list will be disabled
                              when you disabled this option.
                            </Tooltip>
                          }
                        >
                          <Button
                            variant="secondary"
                            style={{
                              all: "unset",
                              position: "relative",
                              top: "-4px",
                            }}
                          >
                            <IoIosInformationCircleOutline />
                          </Button>
                        </OverlayTrigger>
                      ))}
                    </div>

                    {showPreferredCarriers == true ? (
                      <div class="account_body account_bodyPad preferredCarriersFlex px-0">
                        {fetchedPreferredCarriers.map(
                          (item, index) => (
                            console.log("item", item),
                            (
                              <div className="preferredCarriers" key={index}>
                                <h3>
                                  {item.carrierInfo
                                    ? `${item.carrierInfo} - ${item.account_number}`
                                    : item.account_number}
                                </h3>
                              </div>
                            )
                          )
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </div>
            </Container>
          )}
          {/* CONTAINER FOR CARRIER ROLE */}
          {isRoleCarrier && (
            <Container fluid className="pt-120">
              <div className="quotes_div accountBox">
                <Row>
                  <Col lg={5} md={6}>
                    <div className="account_box">
                      <div className="userInfo">
                        {user_profile_pic && user_profile_pic.length > 0 ? (
                          <Image
                            className="logo ms-3"
                            src={IMAGE_URL + "server/" + user_profile_pic}
                            alt=""
                          />
                        ) : (
                          <HiUser size={100} />
                        )}

                        <div className="uspad">
                          <h1>
                            {[contact_first_name, " ", contact_last_name]}
                          </h1>

                          <h3>{user_account_number}</h3>
                        </div>
                        <div className="langDiv">
                          <Select
                            defaultValue={options[0]}
                            onChange={handlesetSelectedOption}
                            options={options}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={7} md={6}>
                    <div className="braedContact">
                      <Image className="tIcon" src={MessageIcon2} alt=""  height={22} width={22}/>
                      <h3>CONTACT</h3>

                      <Link
                        onClick={() => {
                          setContactModal(true);
                          setModalData({
                            phone: user_phone,
                            code: user_country_code,
                            email: user_email,
                            selectedCountryCode: selectedCountryCode,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link>
                    </div>
                    <div class="account_body braedContactFull1">
                      <div>
                        <h3>Phone</h3>
                        <h4>
                          {" "}
                          {user_phone && user_country_code
                            ? `${user_country_code} ${user_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div >
                        <h3>Email</h3>
                        <h4>{user_email ? user_email : "N/A"}</h4>
                      </div>

                      <div >
                        <h3>Country</h3>
                        <h4>{userDetail ? userDetail?.countryName : "N/A"}</h4>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12}>
                    <div className="braedContact  mt-4">
                      <Image className="tIcon" src={BuildingIcon2} alt=""  height={22} width={22}/>
                      <h3>COMPANY</h3>

                      {/* <Link
                        onClick={() => {
                          setCompanyModal(true);
                          setModalData({
                            Name: company_name,
                            DUNS: duns,
                            Address: user_company_address,
                            SIRET: user_siret,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link> */}
                    </div>
                    <div class="account_body braedContactFull">
                      <div>
                        <h3>Name</h3>
                        <h4>{company_name}</h4>
                      </div>

                      <div className="account_mleft">
                        {/* <h3>{selOption ? "SIRET" : "DUNS"}</h3> */}
                        <h3>{"DUNS"}</h3>

                        {/* <h4>{user_siret ? user_siret : "N/A"}</h4> */}
                        <h4>{DUNS ? DUNS : "N/A"}</h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Address</h3>
                        <h4>
                          {user_company_address ? user_company_address : "N/A"}
                        </h4>
                      </div>

                      {/* <div className="account_mleft">
                  <h3>VAT</h3>
                  <h4>{user_vat ? user_vat : "N/A"}</h4>
                </div> */}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={UserSquare} alt=""  height={22} width={22}/>
                      <h3>Account Owner</h3>
                      <Link
                        onClick={() => {
                          setAccountModal(true);
                          setModalData({
                            Name: accountName ? accountName : accountOnwerName,
                            Phone: accountPhoneNumber,
                            Email: accountEmail,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link>
                    </div>
                    <div class="account_body braedContactFull1">
                      <div className="braedContactFull1">
                        <h3>First Name</h3>
                        <h4>
                          {manager_first_name ? `${manager_first_name}` : "N/A"}
                        </h4>
                      </div>

                      <div className="braedContactFull1"  >
                        <h3>Last Name</h3>
                        <h4>
                          {manager_last_name ? `${manager_last_name}` : "N/A"}
                        </h4>
                      </div>
                      <div className="braedContactFull1"  >
                        <h3>Phone</h3>
                        <h4>
                          {manager_phone && manager_country_code
                            ? `${manager_country_code} ${manager_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="">
                        <h3>Email</h3>
                        <h4>{manager_email ? manager_email : "N/A"}</h4>
                      </div>
                    </div>
                    {/* <div class="account_body align-items-start">
                      <div>
                        <h3>Name</h3>
                        <h4>
                          {manager_last_name
                            ? `${manager_last_name} ${manager_first_name}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Phone</h3>
                        <h4>
                          {manager_phone && manager_country_code
                            ? `${manager_country_code} ${manager_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Email</h3>
                        <h4>{manager_email ? manager_email : "N/A"}</h4>
                      </div>
                    </div> */}
                  </Col>
                  {/* <Col lg={6} md={6}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={PaymentIcon2} alt="" />
                      <h3>PAYMENT </h3>
                      
                    </div>

                    <div class="account_body">
                      <div>
                        <h3>IBAN</h3>
                        <h4 className="mb-1">
                          {user_iban ? user_iban : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>BIC</h3>
                        <h4> {user_bic ? user_bic : "N/A"}</h4>
                      </div>
                    </div>
                  </Col> */}
                </Row>
              </div>
            </Container>
          )}

          {/* CONTAINER FOR CLIENT ROLE */}
          {isRoleClient && (
            <Container fluid className="pt-120">
              <div className="quotes_div accountBox">
                <Row>
                  <Col lg={5} md={6}>
                    <div className="account_box">
                      <div className="userInfo">
                        {user_profile_pic && user_profile_pic.length > 0 ? (
                          <Image
                            className="logo ms-3"
                            src={IMAGE_URL + "server/" + user_profile_pic}
                            alt=""
                          />
                        ) : (
                          <HiUser size={100} />
                        )}

                        <div className="uspad">
                          {/* <h1>{company_name}</h1> */}
                          <h1>{`${manager_first_name} ${manager_last_name}`}</h1>

                          <h3>{user_account_number}</h3>
                        </div>
                        <div className="langDiv">
                          <Select
                            defaultValue={options[0]}
                            onChange={handlesetSelectedOption}
                            options={options}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={7} md={6}>
                    <div className="braedContact">
                      <Image className="tIcon" src={MessageIcon2} alt=""  height={22} width={22}/>
                      <h3>CONTACT</h3>

                      <Link
                        onClick={() => {
                          setContactModal(true);
                          setModalData({
                            phone: user_phone,
                            code: user_country_code,
                            email: user_email,
                            selectedCountryCode: selectedCountryCode,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link>
                    </div>
                    <div class="account_body braedContactFull1">
                      <div>
                        <h3>Phone</h3>
                        <h4>
                          {" "}
                          {user_phone && user_country_code
                            ? `${user_country_code} ${user_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div >
                        <h3>Email</h3>
                        <h4>{user_email ? user_email : "N/A"}</h4>
                      </div>
                      <div >
                        <h3>Country</h3>
                        <h4>{userDetail ? userDetail?.countryName : "N/A"}</h4>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={BuildingIcon2} alt=""  height={22} width={22}/>
                      <h3>COMPANY</h3>

                      {/* <Link
                        onClick={() => {
                          setCompanyModal(true);
                          setModalData({
                            Name: company_name,
                            DUNS: duns,
                            Address: user_company_address,
                            SIRET: user_siret,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link> */}
                    </div>
                    <div class="account_body braedContactFull">
                      <div>
                        <h3>Name</h3>
                        <h4>{company_name}</h4>
                      </div>

                      <div className="account_mleft">
                        {/* <h3>{selOption ? "SIRET" : "DUNS"}</h3> */}
                        <h3>{"DUNS"}</h3>

                        {/* <h4>{user_siret ? user_siret : "N/A"}</h4> */}
                        <h4>{DUNS ? DUNS : "N/A"}</h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Address</h3>
                        <h4>
                          {user_company_address ? user_company_address : "N/A"}
                        </h4>
                      </div>

                      {/* <div className="account_mleft">
                  <h3>VAT</h3>
                  <h4>{user_vat ? user_vat : "N/A"}</h4>
                </div> */}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={UserSquare} alt=""  height={22} width={22}/>
                      <h3>Account Owner </h3>
                      <Link
                        onClick={() => {
                          setAccountModal(true);
                          setModalData({
                            Name: accountName ? accountName : accountOnwerName,
                            Phone: accountPhoneNumber,
                            Email: accountEmail,
                          });
                        }}
                      >
                        <Image className="tIcon" src={EditIcon2} alt="" />
                      </Link>
                    </div>
                    <div class="account_body braedContactFull1">
                      <div >
                        <h3>First Name</h3>
                        <h4>
                          {manager_first_name ? `${manager_first_name}` : "N/A"}
                        </h4>
                      </div>

                      <div className="braedContactFull1" >
                        <h3>Last Name</h3>
                        <h4>
                          {manager_last_name ? `${manager_last_name}` : "N/A"}
                        </h4>
                      </div>
                      <div className="braedContactFull1">
                        <h3>Phone</h3>
                        <h4>
                          {manager_phone && manager_country_code
                            ? `${manager_country_code} ${manager_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="">
                        <h3>Email</h3>
                        <h4>{manager_email ? manager_email : "N/A"}</h4>
                      </div>
                    </div>
                    {/* <div class="account_body align-items-start">
                      <div>
                        <h3>Name</h3>
                        <h4>
                          {manager_last_name
                            ? `${manager_last_name} ${manager_first_name}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Phone</h3>
                        <h4>
                          {manager_phone && manager_country_code
                            ? `${manager_country_code} ${manager_phone}`
                            : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>Email</h3>
                        <h4>{manager_email ? manager_email : "N/A"}</h4>
                      </div>
                    </div> */}
                  </Col>
                  {/* <Col lg={6} md={6}>
                    <div className="braedContact mt-4">
                      <Image className="tIcon" src={PaymentIcon2} alt="" />
                      <h3>PAYMENT </h3>
                     
                    </div>

                    <div class="account_body">
                      <div>
                        <h3>IBAN</h3>
                        <h4 className="mb-1">
                          {user_iban ? user_iban : "N/A"}
                        </h4>
                      </div>
                      <div className="account_mleft">
                        <h3>BIC</h3>
                        <h4> {user_bic ? user_bic : "N/A"}</h4>
                      </div>
                    </div>
                  </Col> */}
                </Row>
              </div>
            </Container>
          )}
        </div>

        <Modal
          show={contactModal}
          onHide={() => {
            // clear_edited_states();
            setContactModal(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>EDIT CONTACT</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="uploadBtn uploadBtn1">
                <input
                  id="upload"
                  type="file"
                  name="myfile"
                  accept=".png,.jpg"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </div>
              <div className="image-container text-center">
                {edit_user_profile_pic ? (
                  <img
                    src={edit_user_profile_pic}
                    style={{
                      width: 100,
                      height: 100,
                      borderRadius: 60,
                      border: "1px solid #ccc",
                    }}
                    alt="Uploaded"
                    className="logo"
                  />
                ) : (
                  <HiUser size={100} />
                )}
                <label
                  style={{ display: "block" }}
                  htmlFor="upload"
                  className="uploadBtnLabel"
                >
                  <Image className="tIcon" src={EditIcon2} alt="" />
                  {/* Upload Image */}
                </label>
              </div>
            </div>
            <div className="counCode countFLEX">
              <Form.Select
                size="lg"
                value={edit_user_country_code}
                onChange={(event) => {
                  console.log(event.target.value);
                  setEditUserCountryCode(event.target.value);
                }}
              >
                {phoneNumberCode.map((option, index) => (
                  <option key={index} value={option.code}>
                    {option && option.abbreviation} ({option.code})
                  </option>
                ))}
              </Form.Select>
              <TextInputWithLabel
                label="Contact phone"
                placeholder="Enter a phone number"
                type="text"
                reqstart="*"
                value={edit_user_phone}
                onChange={(text) => {
                  setEditUserPhone(text.target.value);
                }}
              />
            </div>

            <div className="">
              <Form.Group
                className="form_group formSelect form-select1"
                controlId="formGroupCountry"
              >
                <Form.Label>
                  Country <span className="requiresLable"> *</span>
                </Form.Label>

                <Form.Select
                  name="country"
                  value={country}
                  onChange={handleCounty}
                >
                  <option value="">Select a country</option>
                  {phoneNumberCode.map((option, index) => (
                    <option key={index} value={option.code}>
                      {option.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              {countryError && Submit ? (
                <div
                  style={{
                    fontFamily: "AvenirLTProLight",
                    color: "#FF0000",
                    opacity: 0.6,
                    marginTop: -13,
                  }}
                >
                  {countryError}
                </div>
              ) : null}
            </div>

            {phoneError && Submit && edit_user_phone ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {phoneError}
              </div>
            ) : null}

            {Submit && !edit_user_phone ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {"This field is required"}
              </div>
            ) : null}
            <TextInputWithLabel
              label="Contact Email"
              placeholder="Please Enter Email"
              type="text"
              value={edit_user_email}
              reqstart="*"
              onChange={(text) => setEditUserEmail(text.target.value)}
            />
            {contactEmailError && Submit ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {contactEmailError}
              </div>
            ) : null}
            {(isRoleCarrier || isRoleUser) && (
              <>
                <TextInputWithLabel
                  label="Contact First Name"
                  placeholder="Please Enter Contact First Name"
                  type="text"
                  max={20}
                  value={contactFirstName}
                  reqstart="*"
                  onChange={(text) => setContactFirstName(text.target.value)}
                />
                {contactFirstNameError && Submit ? (
                  <div
                    style={{
                      fontFamily: "AvenirLTProLight",
                      color: "#FF0000",
                      opacity: 0.6,
                      marginTop: -13,
                    }}
                  >
                    {contactFirstNameError}
                  </div>
                ) : null}
                <TextInputWithLabel
                  label="Contact Last Name"
                  placeholder="Please Enter Contact Last Name"
                  type="text"
                  max={20}
                  value={contactLastName}
                  reqstart="*"
                  onChange={(text) => setContactLastName(text.target.value)}
                />
                {contactLastNameError && Submit ? (
                  <div
                    style={{
                      fontFamily: "AvenirLTProLight",
                      color: "#FF0000",
                      opacity: 0.6,
                      marginTop: -13,
                    }}
                  >
                    {contactLastNameError}
                  </div>
                ) : null}
              </>
            )}
            {/* <TextInputWithLabel
              label="Address"
              placeholder="Please Enter Address"
              type="text"
              reqstart="*"
              value={edit_user_company_address}
              onChange={(text) => setEditUserCompanyAddress(text.target.value)}
            />

            {companyAddressError && Submit ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {companyAddressError}
              </div>
            ) : null} */}
          </Modal.Body>
          <Modal.Footer>
            <Button
              style={{ width: 180 }}
              variant="primary"
              onClick={() => onSubmit("CONTACT")}
              disabled={editContactLoading}
              className="btn-ok"
            >
              {editContactLoading ? <Loader /> : "Save Changes"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={companyModal}
          onHide={() => {
            // clear_edited_states();
            setCompanyModal(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>EDIT COMPANY</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TextInputWithLabel
              label="Name"
              placeholder="Enter a name"
              type="text"
              reqstart="*"
              value={edit_company_name}
              onChange={(text) => setEditCompanyName(text.target.value)}
              readOnly={isRoleUser ? true : false}
            />
            {conTactCompanyNameError && Submit ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {conTactCompanyNameError}
              </div>
            ) : null}

            <TextInputWithLabel
              label={selOption ? "SIRET" : "DUNS"}
              placeholder={`Please Enter ${selOption ? "SIRET" : "DUNS"}`}
              type="text"
              reqstart="*"
              value={edit_user_siret}
              onChange={(text) => {
                setEditUserSiret(text.target.value);
              }}
            />
            {userSiretError && Submit ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {userSiretError}
              </div>
            ) : null}
            <TextInputWithLabel
              label="Address"
              placeholder="Please Enter Address"
              type="text"
              reqstart="*"
              value={edit_user_company_address}
              onChange={(text) => setEditUserCompanyAddress(text.target.value)}
            />

            {companyAddressError && Submit ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {companyAddressError}
              </div>
            ) : null}

            <TextInputWithLabel
              label="RCS"
              placeholder="Please Enter RCS"
              type="text"
              reqstart="*"
              value={edit_rcs}
              onChange={(text) => setEditRcs(text.target.value)}
            />
            <TextInputWithLabel
              label="VAT NUMBER"
              placeholder="Please Enter VAT NUMBER"
              type="text"
              reqstart="*"
              value={edit_user_vat}
              onChange={(text) => setEditUserVat(text.target.value)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              style={{ width: 154 }}
              variant="primary"
              onClick={() => onSubmit("COMPANY")}
              disabled={editCompanyLoading}
              className="btn-ok"
            >
              {editCompanyLoading ? <Loader /> : "Save Changes"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={accountModal}
          onHide={() => {
            // clear_edited_states();
            setAccountModal(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isRoleStaff ? "EDIT MANAGER" : "EDIT ACCOUNT OWNER"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TextInputWithLabel
              label="First Name"
              placeholder="Enter a name"
              type="text"
              reqstart="*"
              value={edit_manager_first_name}
              onChange={(text) => setEditManageFirstrName(text.target.value)}
            />
            {userFirstNameErr && Submit ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {userFirstNameErr}
              </div>
            ) : null}

            <TextInputWithLabel
              label="Last Name"
              placeholder="Enter a name"
              type="text"
              reqstart="*"
              value={edit_manager_last_name}
              onChange={(text) => setEditManagerLastName(text.target.value)}
            />
            {userLastNameErr && Submit ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {userLastNameErr}
              </div>
            ) : null}

            <div className="counCode countFLEX">
              <Form.Select
                size="lg"
                value={edit_manager_country_code}
                onChange={(e) => {
                  setEditManagerCountryCode(e.target.value);
                }}
              >
                {phoneNumberCode.map((option, index) => (
                  <option key={index} value={option.code}>
                    {option && option.abbreviation} ({option.code})
                  </option>
                ))}
              </Form.Select>
              <TextInputWithLabel
                label="Phone"
                placeholder="Enter a phone number"
                type="text"
                reqstart="*"
                value={edit_manager_phone}
                onChange={(text) => {
                  setEditManagerPhone(text.target.value);
                  // SERVICE.setNumberValidation(text, setAccountOwnerPhone);
                }}
              />
            </div>
            {phoneError && Submit && edit_manager_phone ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {phoneError}
              </div>
            ) : null}
            {Submit && !edit_manager_phone ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {"This field is required"}
              </div>
            ) : null}
            <TextInputWithLabel
              label="Email"
              placeholder="Please Enter Email"
              type="text"
              reqstart="*"
              value={edit_manager_email}
              onChange={(text) => setEditManagerEmail(text.target.value)}
            />
            {contactEmailError && Submit ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {contactEmailError}
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-ok"
              onClick={() => onSubmit("MANAGER")}
              style={{ width: 154 }}
              disabled={editManagerLoading}
            >
              {editManagerLoading ? <Loader /> : "Save Changes"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={preferredCarriersModal}
          onHide={() => {
            setPreferredCarriersModal(false);
          }}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>{"Preferred Carriers"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isLoadingCarriers ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100%" }}
              >
                <Loader color="#f7ce6c" />
              </div>
            ) : (
              <div className="group-input">
                {preferredCarriers.map((carrier, index) => (
                  <React.Fragment key={index}>
                    <div className="d-flex align-items-center gap-2 w-100">
                      <TextInputWithLabel
                        label={`Carrier ${index + 1}`}
                        placeholder="Enter account number"
                        type="text"
                        reqstart="*"
                        value={carrier.account_number}
                        onChange={(e) =>
                          handleCarrierInputChange(index, e.target.value)
                        }
                        onBlur={() => handleAddCarrier(index)}
                        inputStyle={{ width: "100%" }}
                      />

                      <Button
                        variant="danger"
                        onClick={() => handleRemoveCarrier(index)}
                        style={{
                          borderRadius: 100,
                          padding: 0,
                          width: 40,
                          height: 40,
                        }}
                      >
                        <RxCrossCircled size={24} />
                      </Button>
                    </div>
                    {carrier.error && (
                      <span
                        className="text-danger d-block"
                        style={{
                          marginTop: -13,
                          marginBottom: 10,
                          fontSize: "13px",
                        }}
                      >
                        {carrier.error}
                      </span>
                    )}
                  </React.Fragment>
                ))}
                {preferredCarriers.length >= 10 && (
                  <div className="text-danger mb-3" style={{ fontSize: 13 }}>
                    Maximum 10 carriers allowed
                  </div>
                )}
                <Button
                  variant="success"
                  style={{ borderRadius: 100, fontSize: 14 }}
                  onClick={handleAddNewCarrierField}
                  disabled={preferredCarriers.length >= 10}
                >
                  + Add Carrier
                </Button>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-ok"
              style={{ width: 180 }}
              disabled={isSavingCarriers}
              onClick={handleSavePreferredCarriers}
            >
              {isSavingCarriers ? <Loader /> : "Save Changes"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={paymentModal}
          onHide={() => {
            setPaymentModal(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>EDIT PAYMENT</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TextInputWithLabel
              label="IBAN"
              placeholder="Please Enter IBAN"
              type="text"
              reqstart="*"
              value={edit_user_iban}
              onChange={(text) => {
                if (text.target.value.length <= 25) {
                  setEditUserIban(text.target.value);
                }
              }}
            />
            {ibanError && Submit ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {ibanError}
              </div>
            ) : null}
            <TextInputWithLabel
              label="BIC"
              placeholder="Please Enter BIC"
              type="text"
              reqstart="*"
              value={edit_user_bic}
              onChange={(text) => {
                if (text.target.value.length <= 25) {
                  setEditUserBic(text.target.value);
                }
              }}
            />
            {bicError && Submit ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {bicError}
              </div>
            ) : null}
            {/* <TextInputWithLabel
              label="VAT"
              placeholder="Please Enter VAT"
              type="text"
              reqstart="*"
              value={edit_user_vat}
              onChange={(text) => {
                if (text.target.value.length <= 25) {
                  setEditUserVat(text.target.value);
                }
              }}
            /> */}
            {userVatError && Submit ? (
              <div
                style={{
                  fontFamily: "AvenirLTProLight",
                  color: "#FF0000",
                  opacity: 0.6,
                  marginTop: -13,
                }}
              >
                {userVatError}
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button
              style={{ width: 180 }}
              disabled={editPaymentLoading}
              variant="primary"
              onClick={() => onSubmit("PAYMENT")}
              className="btn-ok"
            >
              {editPaymentLoading ? <Loader /> : "Save Changes"}
            </Button>
          </Modal.Footer>
        </Modal>
        <ToastContainer />
      </div>
    </React.Fragment>
  );
};

export default Account;
